import React from 'react';
import '/Users/jilin/projects/antd/rc-dialog/docs/demo/pure.md?watch=parent';
import * as docs_demo_pure_demo_pure_deps_1 from 'react';
import * as docs_demo_pure_demo_pure_deps_2 from 'rc-dialog';
import * as docs_demo_pure_demo_pure_deps_3 from 'rc-select/assets/index.less';
import * as docs_demo_pure_demo_pure_deps_4 from '/Users/jilin/projects/antd/rc-dialog/assets/index.less';
export const demos = {
  'docs-demo-pure-demo-pure': {
    component: React.memo(React.lazy(() => import( /* webpackChunkName: "demos" */ '/Users/jilin/projects/antd/rc-dialog/docs/examples/pure.tsx?techStack=react'))),
    asset: {
  "type": "BLOCK",
  "id": "docs-demo-pure-demo-pure",
  "refAtomIds": [],
  "dependencies": {
    "index.tsx": {
      "type": "FILE",
      "value": require('/Users/jilin/projects/antd/rc-dialog/docs/examples/pure.tsx?dumi-raw').default
    },
    "react": {
      "type": "NPM",
      "value": "18.3.1"
    },
    "@rc-component/dialog": {
      "type": "NPM",
      "value": "1.0.1"
    },
    "rc-select": {
      "type": "NPM",
      "value": "14.16.6"
    },
    "../../assets/index.less": {
      "type": "FILE",
      "value": require('/Users/jilin/projects/antd/rc-dialog/assets/index.less?dumi-raw').default
    }
  },
  "entry": "index.tsx"
},
    context: {
  "../../assets/index.less": docs_demo_pure_demo_pure_deps_4,
  "react": docs_demo_pure_demo_pure_deps_1,
  "rc-dialog": docs_demo_pure_demo_pure_deps_2,
  "rc-select/assets/index.less": docs_demo_pure_demo_pure_deps_3,
  "/Users/jilin/projects/antd/rc-dialog/assets/index.less": docs_demo_pure_demo_pure_deps_4
},
    renderOpts: {
          
          compile: async (...args) => {
            return (await import('/Users/jilin/projects/antd/rc-dialog/node_modules/_dumi@2.4.17@dumi/dist/client/misc/reactDemoCompiler.js')).default(...args);
          },
        },
  },
};